import { createSlice } from "@reduxjs/toolkit";
import toast from "react-hot-toast";
import { axiosInstance } from "../../../utils/client";

type CartState = {
  isLoading: boolean;
  error: string | false;
  cartItems: any[];
  cartTotal: number;
  cart: any[];
  qtyChanged: boolean;
  isLoggedin: boolean;
  selectedCartItem: any;
  checkOutItems: any[];
  deliveryCharge: number;
  addToCartLoading: boolean;
};

const initialState: CartState = {
  isLoading: false,
  error: false,
  cartItems: [],
  cartTotal: 0,
  cart: [],
  qtyChanged: false,
  isLoggedin: false,
  selectedCartItem: null,
  checkOutItems: [],
  deliveryCharge: 0,
  addToCartLoading: false,
};

const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    addItemsToCart: (state, action) => {
      console.log("🚀 ~ action:", action.payload);

      state.selectedCartItem = null;
      state.isLoggedin = true;

      if (
        action?.payload?.cart?.some(
          (item: any) => item.productVariable === action.payload?.id
        )
      ) {
        state.cart = action?.payload?.cart.map((item: any) => {
          // console.log(
          //   "🚀 ~ state.cart=action?.payload?.cart.map ~ item:",
          //   item
          // );

          if (item.productVariable === action.payload?.id) {
            return {
              ...item,
              quantity: item?.quantity + (action?.payload?.quantity || 1),
            };
          }
          return item;
        });
        state.cartItems = action?.payload?.cartItems.map((item: any) => {
          // console.log(
          //   "🚀 ~ state.cartItems=action?.payload?.cartItems.map ~ item:",
          //   item
          // );
          if (
            item.productVariableResponse?.id === action.payload?.variable.id
          ) {
            return {
              ...item,
              quantity: item?.quantity + (action?.payload?.quantity || 1),
            };
          }
          return item;
        });
        return;
      }
      state.cart = [
        ...action?.payload?.cart,
        {
          id: action.payload?.id,
          quantity: action?.payload?.quantity || 1,
          productVariable: action.payload?.variable.id,
        },
      ];
      state.cartItems = [
        ...action?.payload?.cartItems,
        {
          id: action.payload?.id,
          quantity: action?.payload?.quantity || 1,
          productVariableResponse: action.payload.variable,
        },
      ];
    },
    removeItemsFromCart: (state, action) => {
      // console.log("🚀 ~ action:", action.payload);

      state.cartItems = action.payload.cartItems.filter(
        (item: any) => !action.payload.ids.includes(item.id)
      );
      state.cart = state.cart.filter(
        (item) => !action.payload.ids.includes(item.id)
      );
    },
    clearCart: (state, action) => {
      state.cartItems = [];
    },
    setCart: (state, action) => {
      // console.log(action.payload);
      state.cart = action.payload;
    },
    setCartItems: (state, action) => {
      // console.log(action.payload);
      state.cartItems = action.payload;
    },
    setDeliveryCharge: (state, action) => {
      state.deliveryCharge = action.payload;
    },
    changeQty: (state, action) => {
      if (
        action?.payload?.cart?.some(
          (item: any) => item.id === action.payload?.id
        )
      ) {
        state.cart = action?.payload?.cart.map((item: any) => {
          if (item.id === action.payload?.id) {
            return {
              ...item,
              quantity: action?.payload?.quantity || 1,
            };
          }
          return item;
        });
        state.cartItems = action?.payload?.cartItems.map((item: any) => {
          if (item.id === action.payload?.id) {
            return {
              ...item,
              quantity: action?.payload?.quantity || 1,
            };
          }
          return item;
        });
        return;
      }
    },
    setIsLoggedin: (state, action) => {
      state.isLoggedin = action.payload;
    },
    setSelectedCartItem: (state, action) => {
      state.selectedCartItem = action.payload;
      // console.log("🚀 ~ payload:", action.payload);
    },
    setCheckoutItems: (state, action) => {
      state.checkOutItems = action.payload;
    },
    setAddToCartLoading: (state, action) => {
      state.addToCartLoading = action.payload;
    },
  },
});

export const {
  addItemsToCart,
  removeItemsFromCart,
  clearCart,
  setCart,
  setCartItems,
  changeQty,
  setIsLoggedin,
  setSelectedCartItem,
  setCheckoutItems,
  setDeliveryCharge,
  setAddToCartLoading,
} = cartSlice.actions;

export default cartSlice.reducer;

// ----------------------------------------------------------------------

export function getCart(id: string, businessLocationId: string) {
  return async (dispatch: any, getState: () => any) => {
    try {
      const response = await axiosInstance.get(
        `/cart/filter?userId=${id}&businessLocationId=${businessLocationId}`
      );
      if (response.status === 200) {
        // console.log(response);
        dispatch(
          setCartItems(
            response.data[0] ? response.data[0]?.cartItemResponses : []
          )
        );
        dispatch(
          setCart(
            response.data[0]
              ? response.data[0]?.cartItemResponses?.map((item: any) => ({
                  id: item?.id,
                  quantity: item.quantity,
                  productVariable: item.productVariableResponse?.id,
                }))
              : []
          )
        );
        dispatch(setDeliveryCharge(response.data[0]?.deliveryCharge));
      }
    } catch (error) {
      console.error("Error fetching cart data:", error);
    }
  };
}

export function addToCart(data: {
  variableId: number;
  quantity: number;
  sellingPrice: number;
  sellingPriceWithTax: number;
  variable: any;
  discountId?: number;
}) {
  return async (dispatch: any, getState: () => any) => {
    dispatch(setAddToCartLoading(true));
    const { auth } = getState().auth;
    const { cart, cartItems } = getState().cart;
    const { selectedBusinessLocation } = getState().businessLocation;
    try {
      if (!auth) {
        dispatch(setIsLoggedin(false));
        dispatch(setSelectedCartItem(data));
        return;
      }
      const formattedData = {
        cartItemRequests: [
          {
            productId: data.variableId,
            quantity: data.quantity,
            discountId: data.discountId ? data.discountId : null,
          },
        ],
        userId: auth.userId,
        businessLocationId: selectedBusinessLocation.id,
      };

      const response = await axiosInstance.post("/cart", formattedData);
      console.log("🚀 ~ return ~ response:", response);
      if (response.data.success) {
        toast.success(response.data.message);
        dispatch(setSelectedCartItem(null));
        dispatch(
          addItemsToCart({
            id: response?.data.cart_item_id,
            cart: cart,
            quantity: data.quantity,
            cartItems: cartItems,
            variable: data.variable,
          })
        );
        dispatch(getCart(auth.userId, selectedBusinessLocation.id));
      }
      dispatch(setAddToCartLoading(false));
      return response.data;
    } catch (error) {
      toast.error("Failed to add item to cart");
      console.log(error);
    }
  };
}

export function removeFromCart(ids: number[]) {
  return async (dispatch: any, getState: () => any) => {
    dispatch(setAddToCartLoading(true));
    const { cart, cartItems } = getState().cart;
    try {
      // console.log("🚀 ~ removeFromCart ~ idString:", idString);
      const response = await axiosInstance.delete(`/cart/${ids}`);
      // console.log(response);
      if (response?.data?.success) {
        toast.success(response?.data?.message);
        dispatch(
          removeItemsFromCart({ ids: ids, cart: cart, cartItems: cartItems })
        );
      } else {
        toast.error(response?.data?.message);
      }
      dispatch(setAddToCartLoading(false));
      return response.data;
    } catch (error) {
      console.log("🚀 ~ removeFromCart ~ error:", error);
    }
  };
}

export function changeQuantity(id: number, quantity: number) {
  return async (dispatch: any, getState: () => any) => {
    const { cart, cartItems } = getState().cart;
    // const { dispatch } = store;
    try {
      const response = await axiosInstance.put(`/cart/${id}`, quantity);
      if (response?.data.success) {
        toast.success(response?.data?.message);
        dispatch(
          changeQty({
            id: id,
            cart: cart,
            cartItems: cartItems,
            quantity: quantity,
          })
        );
      } else {
        toast.error(response?.data?.message);
      }
    } catch (error) {
      console.log(error);
    }
  };
}
